import { TThunkAction } from '../../types/redux';
import { getFiltersFailure, getFiltersRequest, getFiltersSuccess } from './actions';
import { EDealType } from '../../types/dealType';
import { fetchPreciseFilters } from '../../api/priceEstimator/fetchPreciseFilters';
import {
  EQueryParameters as ECategory,
  EQueryParameters_1 as EFilterDealType,
} from '../../repositories/price-estimator/v3/get-filters-web/types';
import { IPreciseFiltersData } from '../../types/redux/preciseFilters';

export const getPreciseFilters =
  (category?: ECategory): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    dispatch(getFiltersRequest());

    try {
      const [saleFilters, rentFilters] = await Promise.all([
        fetchPreciseFilters(context, { dealType: EFilterDealType.Sale, category }),
        fetchPreciseFilters(context, { dealType: EFilterDealType.Rent, category }),
      ]);

      dispatch(getFiltersSuccess({ dealType: EDealType.Sale, data: saleFilters as IPreciseFiltersData }));
      dispatch(getFiltersSuccess({ dealType: EDealType.Rent, data: rentFilters as IPreciseFiltersData }));
    } catch (e) {
      dispatch(getFiltersFailure());

      return e;
    }
  };
